import {
  STOCK_ACTION_LABELS,
  STOCK_MODULE_PERMISSION_IDS,
  STOCK_RESOURCE_LABELS,
  StockPermissions,
} from "./stock-bridge";

const AdminPermissions = {
  users: {
    create: "users:create",
    read: "users:read",
    update: "users:update",
    delete: "users:delete",
    ban: "users:ban",
  },
  audit: {
    read: "audit:read",
  },
  jd: {
    create: "jd:create",
    read: "jd:read",
    update: "jd:update",
    delete: "jd:delete",
  },
  jd_mapping: {
    create: "jd_mapping:create",
    read: "jd_mapping:read",
    update: "jd_mapping:update",
  },
  positions: {
    create: "positions:create",
    read: "positions:read",
    update: "positions:update",
    delete: "positions:delete",
  },
  departments: {
    create: "departments:create",
    read: "departments:read",
    update: "departments:update",
    delete: "departments:delete",
  },
  assignments: {
    create: "assignments:create",
    read: "assignments:read",
    update: "assignments:update",
    delete: "departments:delete",
  },
  "org-chart": {
    read: "org-chart:read",
  },
  media: {
    all: "media:all",
  },
  sop: {
    create: "sop:create",
    read: "sop:read",
    update: "sop:update",
    delete: "sop:delete",
  },
  checklists: {
    create: "checklists:create",
    read: "checklists:read",
    update: "checklists:update",
    delete: "checklists:delete",
  },
  forms: {
    create: "forms:create",
    read: "forms:read",
    update: "forms:update",
    delete: "forms:delete",
  },
  flows: {
    create: "flows:create",
    read: "flows:read",
    update: "flows:update",
    delete: "flows:delete",
  },
  qc: {
    create: "qc:create",
    read: "qc:read",
    update: "qc:update",
    delete: "qc:delete",
  },
  qc_record: {
    create: "qc_record:create",
    read: "qc_record:read",
    update: "qc_record:update",
    delete: "qc_record:delete",
  },
  qc_result: {
    read: "qc_result:read",
  },
  kpi: {
    read: "kpi:read",
    create: "kpi:create",
    update: "kpi:update",
    delete: "kpi:delete",
  },
  service_standard: {
    create: "service_standard:create",
    read: "service_standard:read",
    update: "service_standard:update",
    delete: "service_standard:delete",
  },
  internal_audit: {
    create: "internal_audit:create",
    read: "internal_audit:read",
    update: "internal_audit:update",
    delete: "internal_audit:delete",
    summary: "internal_audit:summary:read",
  },
  template: {
    create: "template:create",
    read: "template:read",
    update: "template:update",
    delete: "template:delete",
  },
  contracts: {
    create: "contracts:create",
    read: "contracts:read",
    update: "contracts:update",
    delete: "contracts:delete",
    renew: "contracts:renew",
  },
  quotation_invoice: {
    create: "quotation_invoice:create",
    read: "quotation_invoice:read",
    update: "quotation_invoice:update",
    delete: "quotation_invoice:delete",
  },
  hr_payroll: {
    list: "hr_payroll:list",
    read: "hr_payroll:read",
    create: "hr_payroll:create",
    update: "hr_payroll:update",
    delete: "hr_payroll:delete",
    slip_download: "hr_payroll:slip:download",
    confirm: "hr_payroll:confirm",
    unconfirm: "hr_payroll:unconfirm",
    mark_paid: "hr_payroll:mark_paid",
    audit: "hr_payroll:audit",
  },
  hr_overtime: {
    rules_read: "hr_overtime:rules:read",
    rules_create: "hr_overtime:rules:create",
    rules_update: "hr_overtime:rules:update",
    request_list: "hr_overtime:request:list",
    request_create: "hr_overtime:request:create",
    approve: "hr_overtime:approve",
    list: "hr_overtime:list",
    summary: "hr_overtime:summary",
  },
  hr_leave: {
    types_read: "hr_leave:types:read",
    types_create: "hr_leave:types:create",
    types_update: "hr_leave:types:update",
    entitlements_read: "hr_leave:entitlements:read",
    entitlements_create: "hr_leave:entitlements:create",
    entitlements_update: "hr_leave:entitlements:update",
    request_create: "hr_leave:request:create",
    request_update: "hr_leave:request:update",
    approve: "hr_leave:approve",
    approve_line: "hr_leave:approve_line",
    history: "hr_leave:history",
  },
  hr_company_policy: {
    read: "hr_company_policy:read",
    create: "hr_company_policy:create",
    update: "hr_company_policy:update",
    delete: "hr_company_policy:delete",
    publish: "hr_company_policy:publish",
  },
  hr_promotion: {
    rule_read: "hr_promotion:rule:read",
    rule_create: "hr_promotion:rule:create",
    rule_update: "hr_promotion:rule:update",
    record_read: "hr_promotion:record:read",
    record_create: "hr_promotion:record:create",
    record_update: "hr_promotion:record:update",
    approve: "hr_promotion:approve",
    history: "hr_promotion:history",
  },
  hr_employee_profile: {
    /** ดูรายชื่อพนักงานทั้งหมด */
    list: "hr_employee_profile:list",
    /** ดู profile พนักงานคนอื่น (HR/Admin) */
    read: "hr_employee_profile:read",
    /** สร้าง/แก้ไข profile พนักงาน (HR/Admin) */
    upsert: "hr_employee_profile:upsert",
    /** ดู field อ่อนไหว: บัญชีธนาคาร, เลขบัตร (เฉพาะ HR ระดับสูง) */
    read_sensitive: "hr_employee_profile:read:sensitive",
  },
  hr_salary_advance: {
    /** พนักงาน: ดูรายการคำขอของตัวเอง */
    request_read_self: "hr_salary_advance:request:read:self",
    /** พนักงาน: ยื่นคำขอเบิกเงินเดือนล่วงหน้า */
    request_create: "hr_salary_advance:request:create",
    /** พนักงาน: ยกเลิกคำขอ (เฉพาะ status = pending) */
    request_cancel: "hr_salary_advance:request:cancel",
    /** HR/Admin: ดูรายการคำขอทั้งหมด */
    list: "hr_salary_advance:list",
    /** HR/Admin: ดูรายละเอียดคำขอ */
    read: "hr_salary_advance:read",
    /** HR/Admin: อนุมัติคำขอ */
    approve: "hr_salary_advance:approve",
    /** HR/Admin: ปฏิเสธคำขอ */
    reject: "hr_salary_advance:reject",
    /** Finance/HR: บันทึกการจ่ายเงิน (trigger สร้าง repayment schedule) */
    mark_paid: "hr_salary_advance:mark_paid",
    /** Audit: ดูประวัติและรายงาน */
    audit: "hr_salary_advance:audit",
  },
  mgmt_meeting: {
    read: "mgmt:meeting:read",
    list: "mgmt:meeting:list",
    create: "mgmt:meeting:create",
    update: "mgmt:meeting:update",
    delete: "mgmt:meeting:delete",
  },
  mgmt_project: {
    read: "mgmt:project:read",
    list: "mgmt:project:list",
    create: "mgmt:project:create",
    update: "mgmt:project:update",
    delete: "mgmt:project:delete",
  },
  mgmt_calendar: {
    read: "mgmt:calendar:read",
    create: "mgmt:calendar:create",
    update: "mgmt:calendar:update",
    delete: "mgmt:calendar:delete",
    team: "mgmt:calendar:team",
    settings: "mgmt:calendar:settings",
  },
  mgmt_okr_kpi: {
    read: "mgmt:okr-kpi:read",
    update: "mgmt:okr-kpi:update",
  },
  mgmt_monthly_report: {
    read: "mgmt:monthly-report:read",
    list: "mgmt:monthly-report:list",
    create: "mgmt:monthly-report:create",
    update: "mgmt:monthly-report:update",
    delete: "mgmt:monthly-report:delete",
  },
} as const;

const { users: _stockUsers, audit: _stockAudit, ...stockOnlyPermissions } =
  StockPermissions;

/** Admin ERP + Stock POS permissions (users/audit ใช้ของ Admin) */
export const Permissions = {
  ...AdminPermissions,
  ...stockOnlyPermissions,
} as const;

export { STOCK_MODULE_PERMISSION_IDS };

export const ALL_PERMISSIONS = Object.entries(Permissions).flatMap(
  ([resource, actions]) =>
    Object.entries(actions).map(([action, id]) => ({
      id,
      resource,
      action,
    })),
);

export type PermissionId = (typeof ALL_PERMISSIONS)[number]["id"];

// Human-friendly labels for rendering in UI
export const RESOURCE_LABELS: Record<string, string> = {
  users: "ຜູ້ໃຊ້",
  audit: "ບັນທຶກການກວດກາ",
  jd: "ຄຳອະທິບາຍຕໍາແໜ່ງ",
  jd_mapping: "ການຜູກ JD ກັບຕໍາແໜ່ງ",
  positions: "ຕໍາແໜ່ງ",
  departments: "ພະແນກ",
  "org-chart": "ຜັງອົງກອນ",
  assignments: "ການກໍາຫນົດຕໍາແໜ່ງ",
  media: "ໄຟລ໌",
  sop: "ຂັ້ນຕອນການດໍາເນີນງານ (SOP)",
  checklists: "Checklist",
  forms: "Form Center",
  flows: "Flow",
  qc: "ມາດຕະຖານ QC",
  qc_record: "ບັນທຶກຜົນກວດ QC",
  qc_result: "ສະຫຼຸບຜົນ QC",
  kpi: "KPI",
  service_standard: "ມາດຕະຖານບໍລິການ",
  template: "ແມ່ແບບ",
  internal_audit: "ຜະແນການກວດສອບພາຍໃນ",
  contracts: "ສັນຍາ",
  quotation_invoice: "ເອກະສານການເງິນ (ລາຄາ/ໃບບິນ/ໃບຮັບເງິນ)",
  hr_payroll: "ເງິນເດືອນ",
  hr_overtime: "ລ່ວງເວລາ",
  hr_leave: "ລະບົບການລາ",
  hr_company_policy: "ນະໂຍບາຍບໍລິສັດ",
  hr_promotion: "ເສັ້ນທາງການເຕີບໂຕ",
  hr_salary_advance: "ເບິກເງິນເດືອນລ່ວງໜ້າ",
  mgmt_meeting: "ການຈັດການປະຊຸມ",
  mgmt_project: "ການຈັດການໂຄງການ",
  mgmt_calendar: "ປະຕິທິນວຽກ",
  mgmt_okr_kpi: "OKR/KPI Dashboard",
  mgmt_monthly_report: "ລາຍງານປະຈໍາເດືອນ",
  ...STOCK_RESOURCE_LABELS,
};

export const ACTION_LABELS: Record<string, string> = {
  create: "ສ້າງ",
  read: "ເບິ່ງ",
  update: "ແກ້ໄຂ",
  delete: "ລຶບ",
  ban: "ລະງັບ",
  all: "ເຂົ້າເຖິງໄດ້ທັງໝົດ",
  summary: "ສະຫຼຸບ",
  renew: "ຕໍ່ອາຍຸ",
  list: "ລາຍການ",
  slip_download: "ດາວໂຫຼດໃບເງິນເດືອນ",
  confirm: "ຢືນຢັນ",
  mark_paid: "ບັນທຶກຈ່າຍ",
  audit: "ກວດສອບປະຫວັດ",
  publish: "ເຜີຍແພ່",
  rule_read: "ເບິ່ງກົດເສັ້ນທາງ",
  rule_create: "ສ້າງກົດເສັ້ນທາງ",
  rule_update: "ແກ້ໄຂກົດເສັ້ນທາງ",
  record_read: "ເບິ່ງບັນທຶກການເລື່ອນຂັ້ນ",
  record_create: "ສ້າງບັນທຶກການເລື່ອນຂັ້ນ",
  record_update: "ແກ້ໄຂບັນທຶກການເລື່ອນຂັ້ນ",
  approve: "ອະນຸມັດ",
  approve_line: "ອະນຸມັດຄຳຂໍຂັ້ນສາຍງານ",
  history: "ເບິ່ງປະຫວັດ",
  ...STOCK_ACTION_LABELS,
};

export function parsePermissionId(id: string): {
  resource: string;
  action: string;
} {
  if (id.includes(":")) {
    const parts = id.split(":");
    return { resource: parts[0] ?? "", action: parts.slice(1).join(":") };
  }

  const dot = id.indexOf(".");
  if (dot >= 0) {
    return { resource: id.slice(0, dot), action: id.slice(dot + 1) };
  }

  return { resource: id, action: "" };
}

export function getResourceLabel(resource: string): string {
  return RESOURCE_LABELS[resource] ?? resource;
}

export function getActionLabel(action: string): string {
  return ACTION_LABELS[action] ?? action.replaceAll(".", " ");
}

export function getPermissionLabel(id: PermissionId): string {
  const { resource, action } = parsePermissionId(id as string);
  return `${getActionLabel(action)} ${getResourceLabel(resource)}`;
}

export function getPermissionLabels(ids: PermissionId[]): string[] {
  return ids.map((id) => getPermissionLabel(id));
}
